﻿import { Button } from '@progress/kendo-react-buttons';
import { SliderChangeEvent, SliderProps } from '@progress/kendo-react-inputs';
import { useState } from 'react';
import { MapOutline } from '../../../icons/icons';
import useMap from '../../hooks/use-map';
import { MAX_ZOOM, MIN_ZOOM } from '../MaplibreMap';
import { SliderWithTooltip } from './SliderWithTooltip';

export type ZoomLevelSliderProps = Omit<SliderProps, 'min' | 'max'>;

export default function ZoomLevelSlider(props: ZoomLevelSliderProps) {
    const map = useMap();
    const [mapZoom, setMapZoom] = useState(map?.getZoom());
    return (
        <div className={props.className}>
            <div className="d-flex align-items-center justify-content-between gap-2">
                <div>Zoom level:</div>
                <Button
                    svgIcon={MapOutline}
                    className={'button-no-upper button-small gap-1'}
                    onClick={() => {
                        setMapZoom(map?.getZoom());
                        props.onChange?.({ value: mapZoom } as SliderChangeEvent);
                    }}>
                    Get current zoom
                </Button>
            </div>
            <SliderWithTooltip
                {...{ ...props, className: undefined }}
                className={'w-100'}
                min={MIN_ZOOM}
                max={MAX_ZOOM}></SliderWithTooltip>
            <div className={'secondary-text'}>
                <span>World</span>
                <span className={'float-end'}>City</span>
            </div>
        </div>
    );
}
